module.exports = __webpack_public_path__ + "img/2024big28.55c12b79.png";